import axios from '@_system/axios/axios.js'
export default {
	path: '/task',
	saveSplitTrade(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/saveSplitTrade', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	decodeaddress(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/decodeaddress', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	ordercompensation(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/ordercompensation', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getorderdelivery(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getorderdelivery', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	senddelivery(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/senddelivery', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	balanceItemReport(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/balanceItemReport', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	}

}